/* unplugin-vue-components disabled */import { render } from "./PunishPage.vue?vue&type=template&id=9da54028&scoped=true"
import script from "./PunishPage.vue?vue&type=script&lang=js"
export * from "./PunishPage.vue?vue&type=script&lang=js"

import "./PunishPage.vue?vue&type=style&index=0&id=9da54028&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/zeta-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9da54028"]])

export default __exports__